import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './PendientesPage.css';
import { useSelector } from 'react-redux';
import { jwtDecode } from 'jwt-decode';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import API_BASE_URL from '../config';

const moment = require('moment-timezone');

const PendingServicesPage = () => {
  const [pendingServices, setPendingServices] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [colaboradores, setColaboradores] = useState([]);
  const [selectedService, setSelectedService] = useState(null);
  const [search, setSearch] = useState('');
  const token = useSelector((state) => state.auth.token);
  const decoded = token ? jwtDecode(token) : {};
  const estacion = decoded.estacion?.trim().toUpperCase();

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}api/servicios/pendientes-hoy`, {
            headers: { Authorization: `Bearer ${token}` }
          });
          
          const hoy = moment().tz('America/Mexico_City').format('YYYY-MM-DD');

          const filtered = response.data.filter((s) =>
            s.statusServicio === 'PENDIENTE' &&
            s.estacion?.trim().toUpperCase() === estacion           );
          
        setPendingServices(filtered);
      } catch (err) {
        console.error(err);
        toast.error('Error al cargar servicios pendientes.');
      }
    };

    if (token && estacion) fetchServices();
  }, [token, estacion]);

  const openAssignModal = async (servicio) => {
    setSelectedService(servicio);
    setIsModalOpen(true);
    try {
      const res = await axios.get(`${API_BASE_URL}api/bitacora/en-turno-detalles`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const filtrados = res.data.filter(c => c.estacion?.trim().toUpperCase() === estacion);
      setColaboradores(filtrados);
    } catch (err) {
      toast.error('Error al obtener operadores.');
    }
  };

  const asignarServicio = async (operador) => {
    try {
      await axios.put(`${API_BASE_URL}api/servicios/${selectedService.noServicio}`, {
        noColaborador: operador.noColaborador,
        statusServicio: 'EN CURSO',
        sillaRuedas: operador.sillaAsignada,
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success('Servicio asignado correctamente');
      setIsModalOpen(false);
      setPendingServices(pendingServices.filter(s => s.noServicio !== selectedService.noServicio));
    } catch (err) {
      toast.error('Error al asignar servicio');
    }
  };

  const cancelarServicio = async (servicio) => {
    try {
      await axios.put(`${API_BASE_URL}api/servicios/${servicio.noServicio}`, {
        statusServicio: 'CANCELADO',
        horaFin: moment().tz('America/Mexico_City').format('YYYY-MM-DD HH:mm:ss')
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success('Servicio cancelado');
      setPendingServices(pendingServices.filter(s => s.noServicio !== servicio.noServicio));
    } catch (err) {
      toast.error('Error al cancelar servicio');
    }
  };

  const filteredColaboradores = search.trim()
  ? colaboradores.filter(c =>
      c.siglas?.toLowerCase().includes(search.toLowerCase())
    )
  : colaboradores;


  return (
    <div className="pending-services-container">
      <ToastContainer />
      <h2>Servicios Pendientes</h2>
      <div className="services-grid">
        {pendingServices.map(servicio => (
          <div key={servicio.noServicio} className="service-card">
            <p><strong>No Servicio:</strong> {servicio.noServicio}</p>
            <p><strong>Pax:</strong> {servicio.nombrePax}</p>
            <p><strong>Aerolínea:</strong> {servicio.aerolinea}</p>
            <p><strong>Vuelo:</strong> {servicio.noVuelo}</p>
            <p><strong>Silla:</strong> {servicio.sillaRuedas}</p>
            <p><strong>ETA:</strong> {servicio.eta}</p>
            <div className="actions">
              <button onClick={() => openAssignModal(servicio)} className="btn-asignar">Asignar</button>
              <button onClick={() => cancelarServicio(servicio)} className="btn-cancelar">Cancelar</button>
            </div>
          </div>
        ))}
      </div>

      {isModalOpen && (
        <div className="modal-overlay" onClick={() => setIsModalOpen(false)}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <h3>Selecciona un operador</h3>
            <input
              type="text"
              placeholder="Buscar siglas o nombre..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="search-input"
            />
            <ul className="colaboradores-list">
              {filteredColaboradores.map(c => (
                <li key={c.noColaborador} onClick={() => asignarServicio(c)}>
                  {c.siglas} - {c.nombreCompleto} (Silla: {c.noSilla})
                </li>
              ))}
            </ul>
            <button className="btn-cancel" onClick={() => setIsModalOpen(false)}>Cerrar</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default PendingServicesPage;
